import { cn } from '@/shared/lib/cn';
import type * as React from 'react';

/**
 * Text input primitive. React 19 style — a plain function component with
 * `React.ComponentProps<'input'>`; `ref` is a normal prop and is forwarded to the
 * `<input>` through `...props` (no `forwardRef`), matching the other `ui/`
 * primitives (`avatar`, `alert`, `dialog`).
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-md border bg-background px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:shadow-none md:text-sm',
        'focus-visible:border-ring',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
